import React from "react";
import { Button } from "react-bootstrap";
import "../../../stylesheets/components/Reports/PositionReports/PnlReport/ConfirmationPopup.scss";
const ConfirmationPopupMob = (props) => {
    const splitedText = props.description.split(". ");
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ed-generic-modal-edit" },
            React.createElement("div", { className: "" },
                React.createElement("div", { className: `ed-generic-modal ${props.popTitle
                        .toLowerCase()
                        .replace(" ", "-")} ${props.popupClass}` },
                    React.createElement("div", { className: "ed-generic-header" },
                        React.createElement("div", { className: "modal-title" }, props.popTitle)),
                    React.createElement("div", { className: "modal-body" },
                        splitedText[0],
                        ".",
                        React.createElement("br", null),
                        " ",
                        splitedText[1]),
                    React.createElement("div", { className: "ed-generic-off-footer" },
                        props.goBackBtn ? (React.createElement(Button, { className: "go-back", onClick: props.btnFirstCta }, props.btnFirstTitle)) : (React.createElement(Button, { className: "review-changes", onClick: props.btnFirstCta }, props.btnFirstTitle)),
                        React.createElement(Button, { className: "confirm", onClick: props.btnSecCta }, props.btnSecTitle)))))));
};
export default ConfirmationPopupMob;
